<template>
  <div>
    <i-select :value="id" :filterable="true" @input="input">
      <i-option v-for="(item, key) in list" :key="key" :label="item.name" :value="item.value" />
    </i-select>
  </div>
</template>
<script>
  export default {
    props: {
      id: {
        type: [String, Number],
        default: 0
      }
    },
    computed: {
      list() {
        return [
          { value: 0, name: this.$t('autocaller_v2.campaign.select.type.synchronous') },
          { value: 1, name: this.$t('autocaller_v2.campaign.select.type.asynchronous') }
        ];
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
